import { graphql, useStaticQuery } from "gatsby";

export const useNavItems = ({ showOnHeader = null, showOnFooter = null }) => {
    const { navItems } = useStaticQuery(graphql`
        query NavItemsQuery {
            navItems: allContentfulNavigationItem(
                filter: { displayAsTop: { eq: true } }
                sort: { order: ASC }
            ) {
                nodes {
                    id
                    title
                    externalLink
                    htmlId
                    cssClasses
                    page {
                        path
                    }
                    showOnHeader
                    showOnFooter
                    openInNewTab
                    childrenItems {
                        id
                        title
                        page {
                            path
                        }
                        externalLink
                        htmlId
                        showOnHeader
                        showOnFooter
                        cssClasses
                    }
                }
            }
        }
    `);

    if (showOnHeader === null && showOnFooter === null) {
        return navItems.nodes;
    }

    return navItems.nodes
        ?.filter(
            navItem =>
                navItem.showOnHeader === showOnHeader ||
                navItem.showOnFooter === showOnFooter
        )
        ?.map(navItem => ({
            ...navItem,
            childrenItems: navItem.childrenItems?.filter(
                item =>
                    item.showOnHeader === showOnHeader ||
                    item.showOnFooter === showOnFooter
            ),
        }));
};
